import { useGetApiData } from "shared/datalayer";
import RegApi from "apps/registration/enum/RegApi";
import { useRegDetail } from "shared/context/regDetail";
import { ApiInvoicePaymentRequest } from "shared/types/ApiInvoicePaymentRequest";

/**
 * @method useGetInvoicePaymentRequestByRegParticipantIdAndPurchaseOrderId
 * @description This is used to get transaction details based on registrationParticipantId & purchaseOrderId
 * @param invoicePayerPaymentRequested
 * @param registrationParticipantId
 * @param purchaseOrderId
 */
export function useGetInvoicePaymentRequestByRegParticipantIdAndPurchaseOrderId(
  invoicePayerPaymentRequested: boolean,
  registrationParticipantId: string,
  purchaseOrderId: string
) {
  const { invoicePaymentEnabled } = useRegDetail();
  return useGetApiData<ApiInvoicePaymentRequest>(
    RegApi.GET_TRANSACTION_REQUEST_BY_RPID_AND_POID,
    { params: { registrationParticipantId, purchaseOrderId } },
    {
      enabled:
        invoicePayerPaymentRequested &&
        Boolean(invoicePaymentEnabled) &&
        Boolean(registrationParticipantId) &&
        Boolean(purchaseOrderId)
    }
  );
}
